module.exports = __webpack_public_path__ + "static/media/fc-hrtl-unselected.c9291336.webp";